const initialState = null;

const ReservationCheckUncheckReducer = (state = initialState, action) => {
  switch (action.type) {
    case "setReservationCheckedUnchecked":
      state = action.payload;
      return state;
    default:
      return state;
  }
};

export default ReservationCheckUncheckReducer;
